class Tabs {
  constructor(container) {
    this.container = container;
    this.tabs = this.container.querySelectorAll('[data-target]');
  }

  init() {
    let first = true;
    for (let tab of this.tabs) {
      const target = this.container.querySelector(
        `#${tab.getAttribute('data-target')}`
      );
      if (first) {
        tab.classList.add('js-active');
        target.classList.add('js-active');
        first = false;
      }

      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const activeTabs = this.container.querySelectorAll('.js-active');
        for (let activeTab of activeTabs) {
          activeTab.classList.remove('js-active');
        }

        const otherTabs = this.container.querySelectorAll(
          '.tabbed-content__tab-link'
        );
        for (let otherTab of otherTabs) {
          otherTab.setAttribute('aria-selected', 'false');
        }

        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('js-active');
        target.classList.add('js-active');
      });
    }
  }
}

export default Tabs;
